import {Injectable} from '@angular/core';
import {ConfigService} from './config.service';
import {HttpClient} from '@angular/common/http';
import {LoanRestructure, LoanRestructureStatus} from '../model/loan-restructure';
import {LoanDues} from '../model/loan-dues';
import {WriteOffTag} from '../model/WriteOff';
import moment = require('moment');

@Injectable()
export class LoanRestructureService {
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    public async getByLoanId(loanId: string): Promise<LoanRestructure[]> {
        const url = `${this.configService.getLoanServiceUrl()}/loan-restructures?loanId=${loanId}`;
        return await this.httpClient.get<LoanRestructure[]>(url).toPromise();
    }

    public async getLatestRestructuringByLoanId(loanId: string): Promise<LoanRestructure> {
        const loanRestructurings = await this.getByLoanId(loanId);
            return loanRestructurings && loanRestructurings.length > 0 ?
                loanRestructurings.sort((a, b) => moment(b.restructuredOn).toDate().getTime()
                - moment(a.restructuredOn).toDate().getTime())[0] : undefined;
    }

    public async getByLoanIdAnsStatuses(loanId: string, statuses?: LoanRestructureStatus[]): Promise<LoanRestructure[]> {
        const loanRestructures = await this.getByLoanId(loanId);
        if (statuses) {
            return loanRestructures.filter(loanRestructure => statuses.find(status => status === loanRestructure.status));
        }
        return loanRestructures;
    }

    public getPrincipalOutstandingBeforeRestructuringExcludingWriteOff(duesBeforeRestructure: LoanDues): number {
        let principalOutstanding = duesBeforeRestructure.principal;
        if (duesBeforeRestructure.writeOff && duesBeforeRestructure.writeOff.history.length > 0) {
            let i = duesBeforeRestructure.writeOff.history.length - 1;
            while (i >= 0 && duesBeforeRestructure.writeOff.history[i].tag !== WriteOffTag.LoanRestructure) {
                principalOutstanding -= duesBeforeRestructure.writeOff.history[i].principal;
                i--;
            }
        }
        return principalOutstanding;
    }
}
